import L from 'leaflet';

/**
 * @file mapIcons.js
 * @description Utility functions for creating Leaflet icons and status colors for the project map.
 */

export const STATUS_COLORS = {
    active: '#10b981',    // Green
    paused: '#f59e0b',    // Orange
    completed: '#ef4444', // Red
    archived: '#9ca3af'   // Gray
};

export const PRIMARY_COLOR = '#4f46e5'; // Indigo

/**
 * Creates a custom SVG marker icon based on the project status.
 * @param {string} status - Project status ('active', 'paused', etc.)
 * @returns {L.DivIcon} Leaflet DivIcon
 */
export const createCustomIcon = (status) => {
    const color = STATUS_COLORS[status] || STATUS_COLORS.active;

    const svgHtml = `
        <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 0C10.0294 0 6 4.02944 6 9C6 15.75 15 30 15 30C15 30 24 15.75 24 9C24 4.02944 19.9706 0 15 0Z" fill="${color}"/>
            <circle cx="15" cy="9" r="4" fill="white"/>
        </svg>
    `;

    return L.divIcon({
        html: svgHtml,
        className: 'custom-map-marker',
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30]
    });
};

/**
 * Creates a custom SVG cluster icon based on the markers it contains.
 * @param {L.MarkerCluster} cluster - The cluster object from react-leaflet-cluster
 * @returns {L.DivIcon} Leaflet DivIcon
 */
export const createClusterIcon = (cluster) => {
    const markers = cluster.getAllChildMarkers();
    const projectStati = markers.map(m => m.options.projectStatus);
    const uniqueStati = [...new Set(projectStati)];

    let color = PRIMARY_COLOR;
    if (uniqueStati.length === 1) {
        color = STATUS_COLORS[uniqueStati[0]] || PRIMARY_COLOR;
    }

    const count = markers.length;

    const svgHtml = `
        <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 0C13.3726 0 8 5.37258 8 12C8 21 20 40 20 40C20 40 32 21 32 12C32 5.37258 26.6274 0 20 0Z" fill="${color}"/>
            <circle cx="20" cy="12" r="9" fill="white"/>
            <text x="50%" y="13" dominant-baseline="middle" text-anchor="middle" fill="${color}" font-family="Arial" font-weight="bold" font-size="12">${count}</text>
        </svg>
    `;

    return L.divIcon({
        html: svgHtml,
        className: 'custom-cluster-icon',
        iconSize: [40, 40],
        iconAnchor: [20, 40]
    });
};
